<template>
  <f7-page name="notificaciones-oea" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Notificaciones OEA</f7-nav-title>
      <f7-nav-right>
        <button class="navbar-btn navbar-btn-primary" @click="abrirNueva" v-roles="['ADMIN','DIRECTOR','DTYCAL']">+ Nueva regla</button>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · Reglas y log de envios: lectura directa de notificacionConfig / notificacionLog. -->
    <!-- Para que "en vivo" sea cierto, esas dos lecturas se piden sin la cache de peticiones -->
    <!-- (ver NotificacionConfig.js): aqui mismo se crean y ejecutan reglas. -->
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL']">

      <!-- RESUMEN -->
      <div style="display:flex;gap:8px;padding:8px 12px;align-items:center;border-bottom:1px solid #e8edf3">
        <span style="font-size:12px;color:#0E6251;font-weight:600">{{ configsActivas }} activas</span>
        <span style="font-size:12px;color:#94a3b8">{{ configsPausadas }} pausadas</span>
      </div>

      <!-- LISTA DE REGLAS -->
      <div v-for="c in configs" :key="c.id" style="margin:8px 12px;border:1px solid #e2e8f0;border-radius:8px;padding:12px;background:white" :style="c.activa ? {} : {opacity:0.6}">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">
          <span style="width:8px;height:8px;border-radius:50%" :style="{background: c.activa ? '#22c55e' : '#94a3b8'}"></span>
          <strong style="font-size:13px;color:#1a2744;flex:1">{{ c.nombre }}</strong>
          <span style="font-size:10px;padding:2px 8px;border-radius:10px;font-weight:600" :style="{background: c.tipoInforme === 'INDIVIDUAL' ? '#E3F2FD' : c.tipoInforme === 'ALERTA' ? '#FFF3E0' : '#f0f4f8', color: c.tipoInforme === 'INDIVIDUAL' ? '#1565C0' : c.tipoInforme === 'ALERTA' ? '#E65100' : '#1a2744'}">{{ c.tipoInforme }}</span>
          <span style="font-size:10px;padding:2px 8px;border-radius:10px;background:#f0f4f8;color:#64748b;font-weight:500">{{ c.tipoReporte }}</span>
        </div>
        <div style="font-size:11px;color:#64748b;margin-bottom:8px">{{ c.descripcion || '' }}</div>
        <div style="display:flex;gap:16px;font-size:10px;color:#94a3b8;margin-bottom:8px">
          <span><strong>Frecuencia:</strong> {{ formatFrecuencia(c) }}</span>
          <span><strong>Grupos:</strong> {{ (c.grupos || []).join(', ') || 'Ninguno' }}</span>
          <span v-if="c.ultimoEnvio"><strong>Último:</strong> {{ new Date(c.ultimoEnvio).toLocaleString('es-ES') }} <span :style="{color: c.ultimoEstado === 'OK' ? '#22c55e' : c.ultimoEstado === 'ERROR' ? '#dc3545' : '#ffc107'}">{{ c.ultimoEstado }}</span></span>
        </div>
        <div style="display:flex;gap:6px">
          <button style="font-size:10px;padding:4px 10px;border:1px solid #ddd;border-radius:4px;cursor:pointer;background:white" @click="editarConfig(c)">Editar</button>
          <button style="font-size:10px;padding:4px 10px;border-radius:4px;cursor:pointer;border:none" :style="{background: c.activa ? '#fef3cd' : '#d1e7dd', color: c.activa ? '#856404' : '#0f5132'}" @click="toggleActiva(c)">{{ c.activa ? 'Pausar' : 'Activar' }}</button>
          <button style="font-size:10px;padding:4px 10px;background:#0E6251;color:white;border:none;border-radius:4px;cursor:pointer" @click="ejecutarAhora(c)">Enviar ahora</button>
          <button style="font-size:10px;padding:4px 10px;background:none;color:#dc3545;border:1px solid #fecaca;border-radius:4px;cursor:pointer" @click="eliminarConfig(c)">Eliminar</button>
        </div>
      </div>

      <div v-if="!configs.length" style="text-align:center;padding:40px;color:#94a3b8;font-size:13px">
        No hay reglas de notificación. Pulsa "+ Nueva regla" para crear la primera.
      </div>

      <!-- HISTORIAL -->
      <div v-if="logs.length" style="padding:12px">
        <div style="font-size:12px;font-weight:700;color:#1a2744;margin-bottom:8px;text-transform:uppercase;letter-spacing:0.04em">Historial de envíos</div>
        <table style="width:100%;border-collapse:collapse;font-size:11px">
          <thead><tr style="background:#1a2744;color:#c8d3e5">
            <th style="padding:6px 8px;text-align:left">Fecha</th>
            <th style="padding:6px 8px;text-align:left">Tipo</th>
            <th style="padding:6px 8px;text-align:right">Destinatarios</th>
            <th style="padding:6px 8px;text-align:center">Estado</th>
          </tr></thead>
          <tbody><tr v-for="l in logs" :key="l.id" style="border-bottom:1px solid #f0f0f0">
            <td style="padding:5px 8px;color:#64748b">{{ new Date(l.fechaEnvio).toLocaleString('es-ES') }}</td>
            <td style="padding:5px 8px">{{ l.tipoReporte }} {{ l.tipoInforme }}</td>
            <td style="padding:5px 8px;text-align:right">{{ l.totalDestinatarios }}</td>
            <td style="padding:5px 8px;text-align:center"><span style="padding:1px 6px;border-radius:8px;font-size:10px;font-weight:600" :style="{background: l.estado === 'ENVIADO' ? '#d1e7dd' : l.estado === 'ERROR' ? '#f8d7da' : '#fff3cd', color: l.estado === 'ENVIADO' ? '#0f5132' : l.estado === 'ERROR' ? '#842029' : '#664d03'}">{{ l.enviadosOk }}/{{ l.totalDestinatarios }}</span></td>
          </tr></tbody>
        </table>
      </div>
    </f7-page-content>

    <!-- MENSAJE SECCIÓN RESTRINGIDA (solo se muestra si NO es Grupo A) -->
    <f7-page-content v-noroles="['ADMIN','DIRECTOR','DTYCAL']">
      <div style="padding:40px 20px;text-align:center;color:#64748b">
        <div style="font-size:48px;margin-bottom:20px">🔒</div>
        <div style="font-size:18px;font-weight:600;color:#1a2744;margin-bottom:12px">Sección restringida</div>
        <div style="font-size:14px;line-height:1.6;max-width:400px;margin:0 auto">
          Esta sección permite programar envíos automáticos y configurar reportes. Solo disponible para roles de administración.
        </div>
      </div>
    </f7-page-content>

    <!-- POPUP CREAR/EDITAR -->
    <f7-popup :opened="popupConfig" @popup:closed="popupConfig = false" class="popup-notif-config">
      <f7-page>
        <f7-navbar :title="editando ? 'Editar regla' : 'Nueva regla'">
          <f7-nav-right><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <f7-block-title>Nombre</f7-block-title>
          <f7-block strong><input v-model="form.nombre" type="text" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box" placeholder="Ej: Seguimiento diario comerciales"></f7-block>

          <f7-block-title>Tipo informe</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:8px">
              <div v-for="t in ['GLOBAL','INDIVIDUAL','ALERTA']" :key="t" @click="form.tipoInforme = t" style="flex:1;padding:8px;text-align:center;border-radius:6px;cursor:pointer;font-size:11px;font-weight:600" :style="form.tipoInforme === t ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)'} : {border:'1px solid #ddd'}">{{ t }}</div>
            </div>
          </f7-block>

          <f7-block-title>Tipo reporte</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:8px">
              <div v-for="t in ['DIARIO','SEMANAL','MENSUAL']" :key="t" @click="form.tipoReporte = t" style="flex:1;padding:8px;text-align:center;border-radius:6px;cursor:pointer;font-size:11px;font-weight:600" :style="form.tipoReporte === t ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)'} : {border:'1px solid #ddd'}">{{ t }}</div>
            </div>
          </f7-block>

          <f7-block-title>Frecuencia</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:6px;flex-wrap:wrap">
              <button v-for="f in ['DIARIA','SEMANAL','MENSUAL','INTERVALO','PUNTUAL']" :key="f" @click="form.frecuencia = f" style="padding:6px 12px;border-radius:4px;font-size:11px;cursor:pointer;font-weight:500" :style="form.frecuencia === f ? {background:'#2d5f8a',color:'white',border:'none'} : {background:'white',border:'1px solid #ddd',color:'#64748b'}">{{ f }}</button>
            </div>
          </f7-block>

          <!-- Campos condicionales -->
          <f7-block strong v-if="form.frecuencia === 'DIARIA' || form.frecuencia === 'SEMANAL' || form.frecuencia === 'MENSUAL'">
            <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
              <label style="font-size:11px;color:#64748b">Hora:</label>
              <input v-model="form.hora" type="time" style="padding:4px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px">
              <label v-if="form.frecuencia === 'SEMANAL'" style="font-size:11px;color:#64748b;margin-left:8px">Día:</label>
              <select v-if="form.frecuencia === 'SEMANAL'" v-model="form.diaSemana" style="padding:4px;border:1px solid #ddd;border-radius:4px;font-size:12px">
                <option v-for="d in ['LUNES','MARTES','MIERCOLES','JUEVES','VIERNES','SABADO','DOMINGO']" :key="d" :value="d">{{ d }}</option>
              </select>
              <label v-if="form.frecuencia === 'MENSUAL'" style="font-size:11px;color:#64748b;margin-left:8px">Día mes:</label>
              <input v-if="form.frecuencia === 'MENSUAL'" v-model.number="form.diaMes" type="number" min="1" max="28" style="width:50px;padding:4px;border:1px solid #ddd;border-radius:4px;font-size:12px">
              <label style="font-size:11px;color:#64748b;margin-left:8px"><input type="checkbox" v-model="form.soloLaborables"> Solo laborables</label>
            </div>
          </f7-block>

          <f7-block strong v-if="form.frecuencia === 'INTERVALO'">
            <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
              <label style="font-size:11px;color:#64748b">Cada:</label>
              <select v-model.number="form.intervaloMinutos" style="padding:4px;border:1px solid #ddd;border-radius:4px;font-size:12px">
                <option :value="15">15 min</option><option :value="30">30 min</option><option :value="60">60 min</option>
              </select>
              <label style="font-size:11px;color:#64748b">De:</label>
              <input v-model="form.franjaInicio" type="time" style="padding:4px;border:1px solid #ddd;border-radius:4px;font-size:12px">
              <label style="font-size:11px;color:#64748b">a:</label>
              <input v-model="form.franjaFin" type="time" style="padding:4px;border:1px solid #ddd;border-radius:4px;font-size:12px">
              <label style="font-size:11px;color:#64748b"><input type="checkbox" v-model="form.soloLaborables"> Solo L-V</label>
            </div>
          </f7-block>

          <f7-block-title>Destinatarios</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px">
              <span v-for="g in ['TODOS','GC','FV','I/C','DIRECCION']" :key="g" @click="toggleGrupo(g)" style="padding:4px 10px;border-radius:10px;font-size:11px;cursor:pointer;font-weight:500" :style="(form.grupos || []).indexOf(g) > -1 ? {background:'#2d5f8a',color:'white'} : {background:'#f0f4f8',color:'#64748b'}">{{ g }}</span>
            </div>
            <div style="margin-bottom:6px">
              <label style="font-size:10px;color:#64748b;display:block;margin-bottom:2px">Emails extra (coma):</label>
              <input v-model="formEmailsExtra" type="text" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:11px;box-sizing:border-box" placeholder="director@empresa.com">
            </div>
          </f7-block>

          <f7-block-title>Filtrar por personas concretas (opcional)</f7-block-title>
          <f7-block strong>
            <div style="font-size:10px;color:#94a3b8;margin-bottom:8px">Si no seleccionas ninguna, el informe incluye todas las personas del mes.</div>
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">
              <span style="font-size:11px;padding:3px 10px;border-radius:10px;font-weight:600" :style="(form.personasCodigo || []).length === 0 ? {background:'#f0f4f8',color:'#64748b'} : {background:'#E6F1FB',color:'#185FA5'}">{{ personasSeleccionadasLabel }}</span>
              <button v-if="(form.personasCodigo || []).length > 0" @click="limpiarPersonas" style="font-size:10px;padding:3px 8px;border:1px solid #ddd;border-radius:4px;background:white;cursor:pointer;color:#64748b">Limpiar</button>
            </div>
            <div v-if="empleados.length === 0" style="font-size:11px;color:#94a3b8;font-style:italic">Cargando personas...</div>
            <div v-else style="display:grid;grid-template-columns:repeat(2,1fr);gap:4px 8px;max-height:220px;overflow-y:auto;border:1px solid #e5e7eb;border-radius:6px;padding:8px;background:#fafbfc">
              <label v-for="p in empleados" :key="p.codigoPersonal" style="display:flex;align-items:center;gap:6px;font-size:11px;color:#1a2744;cursor:pointer;padding:2px 4px;border-radius:3px" :style="personaSeleccionada(p.codigoPersonal) ? {background:'#E6F1FB'} : {}">
                <input type="checkbox" :checked="personaSeleccionada(p.codigoPersonal)" @change="togglePersona(p.codigoPersonal)" style="cursor:pointer;flex-shrink:0">
                <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap"><strong>{{ p.codigoPersonal }}</strong><span v-if="p.nombre" style="color:#64748b"> — {{ p.nombre }}</span></span>
              </label>
            </div>
          </f7-block>

          <f7-block-title v-if="form.tipoInforme === 'ALERTA'">Umbral %</f7-block-title>
          <f7-block strong v-if="form.tipoInforme === 'ALERTA'">
            <input v-model.number="form.umbralPorcentaje" type="number" min="0" max="100" style="width:80px;padding:6px;border:1px solid #ddd;border-radius:4px;font-size:12px"> %
          </f7-block>

          <f7-block strong>
            <label style="font-size:11px;color:#64748b;display:block;margin-bottom:4px">Mensaje personalizado:</label>
            <textarea v-model="form.mensajePersonalizado" rows="2" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:11px;resize:vertical;box-sizing:border-box"></textarea>
          </f7-block>

          <f7-block strong>
            <label style="font-size:12px"><input type="checkbox" v-model="form.activa"> Activar regla</label>
          </f7-block>

          <f7-block>
            <div style="display:flex;gap:8px">
              <f7-button fill color="green" style="flex:1" @click="guardarConfig">Guardar</f7-button>
              <f7-button outline style="flex:1" @click="popupConfig = false">Cancelar</f7-button>
            </div>
          </f7-block>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
.navbar-btn { font-size:10px;padding:4px 10px;background:rgba(255,255,255,0.15);color:#c8d3e5;border:0.5px solid rgba(255,255,255,0.25);border-radius:4px;cursor:pointer;font-weight:500; }
.navbar-btn-primary { background:#0F6E56 !important;color:white !important;border-color:#0F6E56 !important;font-weight:600; }
.popup-notif-config { --f7-popup-tablet-width:600px; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import avisoNoGuardado from '../../js/utils/avisoNoGuardado.js';
import Oea from '../../js/db/Oea.js';
import NotificacionConfig from '../../js/db/NotificacionConfig.js';
import SelloDatos from '../../components/SelloDatos.vue';

export default {
  components: { SelloDatos },
  data: function() {
    return {
      configs: [],
      logs: [],
      popupConfig: false,
      editando: false,
      form: this.formVacio(),
      formEmailsExtra: '',
      empleados: [],
    };
  },
  computed: {
    configsActivas: function() { return this.configs.filter(function(c) { return c.activa; }).length; },
    configsPausadas: function() { return this.configs.filter(function(c) { return !c.activa; }).length; },
    personasSeleccionadasLabel: function() {
      var n = (this.form.personasCodigo || []).length;
      var total = this.empleados.length;
      if (n === 0) return 'Todas las personas';
      return n + ' de ' + total + ' personas seleccionadas';
    }
  },
  methods: {
    onPageInit: function() { this.cargarDatos(); },
    cargarDatos: function() {
      var self = this;
      NotificacionConfig.getConfiguraciones('OEA').then(function(res) { self.configs = unwrapDto(res) || []; }).catch(function() {});
      NotificacionConfig.getLogs('OEA', 20).then(function(res) { self.logs = unwrapDto(res) || []; }).catch(function() {});
    },
    formVacio: function() {
      return { nombre: '', descripcion: '', modulo: 'OEA', tipoInforme: 'GLOBAL', tipoReporte: 'MENSUAL', frecuencia: 'DIARIA', hora: '08:00', diaSemana: 'LUNES', diaMes: 1, intervaloMinutos: 30, franjaInicio: '08:00', franjaFin: '18:00', soloLaborables: true, grupos: ['TODOS'], personasCodigo: [], emailsExtra: [], umbralPorcentaje: 80, mensajePersonalizado: '', activa: true };
    },
    abrirNueva: function() {
      this.form = this.formVacio();
      this.formEmailsExtra = '';
      this.editando = false;
      this.popupConfig = true;
      this.fetchEmpleados();
    },
    editarConfig: function(c) {
      this.form = JSON.parse(JSON.stringify(c));
      if (!this.form.personasCodigo) this.form.personasCodigo = [];
      this.formEmailsExtra = (c.emailsExtra || []).join(', ');
      this.editando = true;
      this.popupConfig = true;
      this.fetchEmpleados();
    },
    fetchEmpleados: function() {
      var self = this;
      if (self.empleados && self.empleados.length > 0) return;
      Oea.getPersonasConfig().then(function(res) {
        var arr = (res && unwrapDto(res)) ? unwrapDto(res).slice() : [];
        arr.sort(function(a, b) {
          var ca = (a.codigoPersonal || '').toUpperCase();
          var cb = (b.codigoPersonal || '').toUpperCase();
          return ca < cb ? -1 : ca > cb ? 1 : 0;
        });
        self.empleados = arr;
      }).catch(function() { self.empleados = []; });
    },
    toggleGrupo: function(g) {
      if (!this.form.grupos) this.form.grupos = [];
      var idx = this.form.grupos.indexOf(g);
      if (idx > -1) this.form.grupos.splice(idx, 1);
      else this.form.grupos.push(g);
    },
    togglePersona: function(codigo) {
      if (!this.form.personasCodigo) this.form.personasCodigo = [];
      var idx = this.form.personasCodigo.indexOf(codigo);
      if (idx > -1) this.form.personasCodigo.splice(idx, 1);
      else this.form.personasCodigo.push(codigo);
    },
    personaSeleccionada: function(codigo) {
      return (this.form.personasCodigo || []).indexOf(codigo) > -1;
    },
    limpiarPersonas: function() {
      this.form.personasCodigo = [];
    },
    guardarConfig: function() {
      var self = this;
      self.form.emailsExtra = self.formEmailsExtra ? self.formEmailsExtra.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; }) : [];
      NotificacionConfig.crearConfiguracion(self.form).then(function() {
        self.popupConfig = false;
        self.$f7.toast.create({ text: 'Regla guardada', position: 'top', closeTimeout: 2000 }).open();
        self.cargarDatos();
      // #164 · El popup se queda abierto con lo escrito: si se cierra sin decir nada, la regla
      // parece guardada y no lo está, y las notificaciones no se envían.
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la regla de notificación', err);
      });
    },
    toggleActiva: function(c) {
      var self = this;
      NotificacionConfig.toggleConfiguracion(c.id).then(function() { self.cargarDatos(); })
        .catch(function(err) { avisoNoGuardado(self.$f7, 'el cambio de «' + c.nombre + '»', err); });
    },
    ejecutarAhora: function(c) {
      var self = this;
      self.$f7.dialog.confirm('¿Enviar "' + c.nombre + '" ahora?', 'Enviar', function() {
        NotificacionConfig.ejecutarAhora(c.id, {}).then(function(res) {
          var log = unwrapDto(res);
          self.$f7.toast.create({ text: log && log.estado ? 'Enviado: ' + log.enviadosOk + '/' + log.totalDestinatarios : 'Enviado', position: 'top', closeTimeout: 3000 }).open();
          self.cargarDatos();
        }).catch(function(e) {
          self.$f7.toast.create({ text: 'No se ha enviado: ' + (e && e.message ? e.message : 'error desconocido'), position: 'top', closeTimeout: 4000 }).open();
        });
      });
    },
    eliminarConfig: function(c) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + c.nombre + '"?', 'Eliminar', function() {
        NotificacionConfig.eliminarConfiguracion(c.id).then(function() { self.cargarDatos(); })
          .catch(function(err) { avisoNoGuardado(self.$f7, 'el borrado de «' + c.nombre + '»', err); });
      });
    },
    formatFrecuencia: function(c) {
      if (c.frecuencia === 'INTERVALO') return 'Cada ' + c.intervaloMinutos + ' min · ' + (c.franjaInicio || '') + '-' + (c.franjaFin || '') + (c.soloLaborables ? ' L-V' : '');
      if (c.frecuencia === 'DIARIA') return 'Diaria · ' + (c.hora || '') + (c.soloLaborables ? ' L-V' : '');
      if (c.frecuencia === 'SEMANAL') return 'Semanal · ' + (c.diaSemana || '') + ' ' + (c.hora || '');
      if (c.frecuencia === 'MENSUAL') return 'Mensual · Día ' + (c.diaMes || '') + ' ' + (c.hora || '');
      return c.frecuencia || 'Puntual';
    }
  }
};
</script>
